import { Controller } from "@hotwired/stimulus"
import { delegate } from "tippy.js"

// Planroom calendar page: FullCalendar v6 (CDN global) month/list view with event tooltips.
export default class extends Controller {
  static targets = ["calendar", "legend"]
  static values = {
    timeZone: String,
    eventsUrl: { type: String, default: "/pages/calendar/jobs" },
  }

  connect() {
    this.initializeCalendar()
  }

  disconnect() {
    this.tooltipDelegate?.destroy()
    this.tooltipDelegate = null
    this.calendar?.destroy()
    this.calendar = null
  }

  initializeCalendar() {
    if (typeof FullCalendar === "undefined") return

    this.calendar = new FullCalendar.Calendar(this.calendarTarget, {
      timeZone: this.timeZoneValue,
      initialView: "dayGridMonth",
      headerToolbar: { right: "dayGridMonth,listMonth today prev,next" },
      height: "parent",
      weekends: false,
      buttonText: {
        today: "Today",
        dayGridMonth: "Month",
        listMonth: "List",
      },
      dayMaxEvents: true,
      eventSources: [{ url: this.eventsUrlValue }],
      displayEventTime: false,
    })
    this.calendar.render()

    this.mountLegend()
    this.tooltipDelegate = delegate(this.calendarTarget, {
      target: ".fc-day-grid-event",
      content: (element) => element.textContent,
    })
  }

  mountLegend() {
    if (!this.hasLegendTarget) return

    const calendarToolbar = this.calendarTarget.querySelector(".fc-header-toolbar")
    if (!calendarToolbar) return

    this.legendTarget.classList.remove("hidden")
    const lastChunk = calendarToolbar.querySelector(".fc-toolbar-chunk:last-child")
    if (lastChunk) {
      lastChunk.insertBefore(this.legendTarget, lastChunk.firstChild)
    }
  }
}
